<template>
    <div>
        <loading :value="loading" :message='$t("shared.searchAgent.searching")'></loading>
        <v-toolbar flat color="white">
            <v-text-field
                    v-model="search"
                    append-icon="search"
                    :label='$t("shared.common.search")'
                    single-line
                    hide-details
                    @keyup.enter="getData"
            ></v-text-field>
        </v-toolbar>
        <v-card>

        </v-card>
        <transition name="fade">
            <v-data-table
                    :headers="headers" :items="data"
                    class="elevation-1">
                <template v-slot:items="props">
                    <td class="text-xs-start">{{ props.item.id }}</td>
                    <td class="text-xs-start">{{ props.item.username }}</td>
                    <td class="text-xs-start">{{ props.item.email }}</td>
                    <td class="text-xs-start">{{ props.item.first_name }}</td>
                    <td class="text-xs-start">{{ props.item.last_name }}</td>
                    <td class="text-xs-start">
                        {{ ! props.item.deleted_at ? (props.item.approved_at ? $t("shared.searchAgent.active") : $t("shared.searchAgent.inactive")) : $t("shared.searchAgent.archive") }}
                    </td>
                    <td class="text-xs-start">{{ $companyTime(props.item.created_at, 'MMM YYYY') }}</td>
                    <td class="text-xs-start">{{ props.item.deleted_at ? $companyTime(props.item.deleted_at, 'MMM YYYY')
                        : '-' }}
                    </td>
                    <td>
                        <v-icon @click="$router.push(`${provider}/${props.item.id}`)">info</v-icon>
                    </td>
                </template>
            </v-data-table>
        </transition>
    </div>
</template>

<script>
    import DataTable from "@/components/monaco/DataTable";
    import loading from "@/components/LoadingComponent";

    export default {
        name: "Search",
        components: {loading, DataTable},
        props: ['provider'],
        data() {
            return {
                data: [],
                search: '',
                loading: false
            }
        },
        computed: {
            headers() {
                return [
                    {text: '#', value: 'id'},
                    {text: this.$t("shared.searchAgent.username"), value: 'username'},
                    {text: this.$t("shared.searchAgent.email"), value: 'email'},
                    {text: this.$t("shared.searchAgent.firstName"), value: 'first_name'},
                    {text: this.$t("shared.searchAgent.lastName"), value: 'last_name'},
                    {text: this.$t("shared.searchAgent.status"), value: 'status'},
                    {text: this.$t("shared.searchAgent.createdAt"), value: 'created_at'},
                    {text: this.$t("shared.searchAgent.deletedAt"), value: 'deleted_at'}
                ];
            }
        },
        methods: {
            getData() {
                this.loading = true;
                this.axios.get(`${this.provider.slice(0, -1)}?search=${this.search}`)
                    .then(res => {
                        this.data = res.data.data;
                        if (!Array.isArray(this.data)) {
                            this.data = this.data.data;
                        }
                    }).catch(err => console.log(err.message))
                    .finally(() => this.loading = false);
            }
        }
    }
</script>

<style scoped>

</style>